import React from "react";
import styled, { css } from "styled-components";

const StyledIcon = styled.svg`
  fill: none;
  stroke: #454545;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
  stroke-width: 3px;

  ${({ darkMode }) =>
    darkMode == "true" &&
    css`
      stroke: #ffffff;
    `}
`;

const PrevArrow = ({ darkMode }) => {
  return (
    <StyledIcon
      darkMode={darkMode}
      xmlns="http://www.w3.org/2000/svg"
      width="24.622"
      height="46.245"
      viewBox="0 0 24.622 46.245"
    >
      <g transform="translate(1.5 2.121)">
        <path d="M21,0,0,21,21,42" />
      </g>
    </StyledIcon>
  );
};

export default PrevArrow;
